import { createFileRoute } from "@tanstack/react-router";
import { ORMServicePage } from "./services_.orm";

export const Route = createFileRoute("/services_/orm-services")({
  head: () => ({
    meta: [
      {
        title: "ORM Services (Online Reputation Management) — KMWAdvertising",
      },
      {
        name: "description",
        content: "Protect, Monitor & Enhance Corporate Digital Reputation.",
      },
    ],
  }),
  component: ORMServicePage,
});
